import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {MaterialReactTable} from 'material-react-table';
import PropTypes from 'prop-types';

import Swal from 'sweetalert2';
import {
  MenuItem,
} from '@mui/material';

import {  base_url,Apitoken, Authtoken } from '../Global';
// import $ from "jquery";
const StockFollowUpViewBySupplierLocation = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [stocksgroupby, setStocksgroupby] = useState({});
  const [permission, setPermission] = useState({});
    let season_id = localStorage.getItem("season_id");

  useEffect(() => {
        setPermission(FindModuleById(151)); 
console.log(permission);

    axios
      .get(`/stock-follow-ups/listing-groupby-supplier-location-detail/${id+'_'+season_id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        setData(response.data.data.stocks);
        setStocksgroupby(response.data.data.stocks_groupby_supplier[0]);
    
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);



  // 🔹 Separate Cell Component for "Delivery Note"
const DeliveryNoteCell = ({ row }) => {
  if (row.original?.delivery_note) {
    return (
      <a
        className="btn btn-primary"
        href={viewFile(row.original.delivery_note)} // Ensure viewFile is defined
        target="_blank"
        rel="noopener noreferrer"
        download
      >
        Download
      </a>
    );
  }
  return null; // Return nothing if delivery_note is null
};

// ✅ Define PropTypes
DeliveryNoteCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      delivery_note: PropTypes.string, // Ensure delivery_note is a string
    }),
  }).isRequired,
};


const ValidationCell = ({ row, updateRowData }) => {
     let season_id = localStorage.getItem("season_id");

  const isValidated = row.original.validated === 1;

  const handleValidationChange = (e) => {
    e.stopPropagation();
    const newValidationStatus = e.target.checked ? 1 : 0;

    // Update validation status in your data

    const confirmUpdate = window.confirm(`Are you sure you want to ${newValidationStatus ? 'validate' : 'invalidate'} this item?`);
  
      if (!confirmUpdate) return;
    
      try {
        const response =  axios.patch(
          `/stock-situations/${season_id+'-'+row.original.id}/validate`,
          {
            validated: newValidationStatus,
          },
          {
            headers: {
              Authorization: `Bearer ${Authtoken}`,
              Apitoken: Apitoken,
            },
          }
        );

        console.log(response);
        updateRowData(row.original.id, newValidationStatus);
      
        // Optionally refresh data or show success message
        // queryClient.invalidateQueries('yourQueryKey');
      } catch (error) {
        console.error('Error updating validation status:', error);
        // Show error notification if needed
      }

  };

  return (
    <div className="custom-control custom-checkbox" >
        <input
          type="checkbox"
          className="form-check-input packaging-class form-check-input-validate"
                checked={isValidated}
               onChange={handleValidationChange}
        />
        <label
          className="custom-control-label ms-1"
          htmlFor="cb1"
          style={{paddingTop:"10px"}}
        >
          {/* Packaging */}
        </label>
  </div>
   
    // <input
    //   type="checkbox"
    //   checked={isValidated}
    //   onChange={handleValidationChange}
    //   className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 form-check-input"
    // />
  );
};

// PropTypes validation
ValidationCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      validated: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
    }).isRequired,
  }).isRequired,
  updateRowData: PropTypes.func.isRequired, // Ensure updateRowData is a function
};
// In your parent component (StockFollowUpViewBySupplierLocation):
const updateRowData = (id, newValidationStatus) => {
  setData((prevData) => {
    return prevData.map((item) =>
      item.id === id ? { ...item, validated: newValidationStatus } : item
    );
  });
};
const ValidatedCellRenderer = ({ row }) => (
  <ValidationCell row={row} updateRowData={updateRowData} />
);

ValidatedCellRenderer.propTypes = {
  row: PropTypes.object.isRequired,
};
// 🔹 Column Configuration
const columns = [
  {
    accessorKey: 'location_name',
    header: 'Location',
  },
  {
    accessorKey: 'date',
    header: 'Date',
  },
  {
    accessorKey: 'delivery_note_number',
    header: 'Delivery Note Number',
  },
  {
  accessorKey: 'operation',
  header: 'Operation',
  },
  {
    accessorKey: 'validated',
    header: 'Validation',
    Cell: ValidatedCellRenderer, // Use the component with proper prop validation
  },
  // {
  //   accessorKey: 'validated',
  //   header: 'Validated',
  //   Cell: ({ row }) => (
  //     <ValidationCell row={row} updateRowData={updateRowData} />
  //   ),
  // },
  {
    header: 'Supplier',
    accessorFn: (row) =>
      row.supplier_detail ? row.supplier_detail.name : '',
  },
  {
    header: 'Consumable',
    accessorFn: (row) =>
      row.consumable_product ? row.consumable_product.consumable_name : '',
  },
  {
    accessorKey: 'quantity',
    header: 'Quantity',
  },
  {
    header: 'Unit Price',
    accessorFn: (row) =>
      `${row.unit_price}${row.currency_detail ? row.currency_detail.symbol : ''}`,
  },
  {
    header: 'Total Amount',
    accessorFn: (row) =>
      `${row.total_amount}${row.currency_detail ? row.currency_detail.symbol : ''}`,
  },
  {
    accessorKey: 'note',
    header: 'Note',
  },
  {
    accessorKey: 'created_at',
    header: 'Created',
  },
  {
    header: 'Delivery Note',
    Cell: DeliveryNoteCell, // ✅ Use separate component
  },
];
   const viewFile =(link) =>{
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: link};
    return  s3.getSignedUrl('getObject', params);
  }

 
  const editItem = (item)=>{
    window.location.href = "/stock-situations-edit/"+item;
  }


  const deleteItem = (item) => {
    let season_id = localStorage.getItem("season_id");

    Swal.fire({
      title: 'Do you really want to delete this record?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/stock-follow-ups/delete2/${season_id+'-'+item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                axios
                  .get(`/stock-follow-ups/listing-groupby-supplier-location-detail/${id+'_'+season_id}`, {
                    headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
                  })
                  .then((response) => {
                    setData(response.data.data.stocks);
                    setStocksgroupby(response.data.data.stocks_groupby_supplier[0]);
                
                  })
                  .catch((error) => {
                    console.log(error);
                  });
                // setTimeout(() => {
                //   window.location.href = "/stock-situations";
                // }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            }); 
           }
    });
  }

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
const downloadExcel = () => {
    let season_id = localStorage.getItem("season_id");

  window.open(`${base_url}/stock-follow-ups/export-groupby-supplier-location-detail/${id+'_'+season_id}`, '_blank');

}

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">

            


                <div className="col-sm-12">
                  <h3 className="page-title">Stock Situations Group By Supplier and Location </h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/stock-situations">Stock Situations</Link>
                    </li>
                    <li className="breadcrumb-item active">Stock Situations Group By Supplier and Location</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="row">
            <div className="row">
                
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Quantity IN</div>
                          <div className="dash-counts">
                            <p>{stocksgroupby.total_in_quantity}</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Quantity OUT</div>
                          <div className="dash-counts">
                            <p>{stocksgroupby.total_out_quantity}</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Quantity Available </div>
                          <div className="dash-counts">
                            <p>{(stocksgroupby.total_in_quantity - stocksgroupby.total_out_quantity)}</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                      
                </div>

          
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                  <table className="table table-bordered">
                    <tr>
                      <th  className="p-3">Supplier </th>
                      <td className="p-3">  {stocksgroupby.supplier_detail ? stocksgroupby.supplier_detail.name : ""}</td>
                    </tr>
                    <tr> <th className="p-3">Location </th>
                      <td className="p-3">
                        {stocksgroupby.location_name ? stocksgroupby.location_name : ""}
                      </td>
                    </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
            <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                    <div className="col-md-12" style={{paddingTop:'30px'}}>
                      <button  className="btn btn-primary " style={{'float':'right'}} onClick={() => downloadExcel()} >  Download Excel </button>
                    </div>
                    <div className="col-md-12">
                    <div className="table-responsive">
                          <MaterialReactTable columns={columns} data={data} 
                              enableColumnOrdering
                              enablePinning
                              enableRowActions
                              //renderColumnActionsMenuItems 
                              // renderRowActionMenuItems={({ row }) => [
                              //   <MenuItem key="edit" onClick={() => editItem(row.original.stock_follow_up_id)}>
                              //     Edit
                              //   </MenuItem>,
                            
                              // <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                              //     Delete
                              //   </MenuItem>,
                              // ]}
                              renderRowActionMenuItems={({ row }) => [
                                permission?.update == 1 && (
                                  <MenuItem key="edit" onClick={() => editItem(row.original.stock_follow_up_id)}>
                                    Edit
                                  </MenuItem>
                                ),
                                permission?.delete == 1 && (
                                  <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                    Delete
                                  </MenuItem>
                                ),
                              ]}
                            />
                          </div>
                    </div>

                    </div>

                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default StockFollowUpViewBySupplierLocation;
